import React from 'react'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import cardStyle from './Card.module.scss'
import style from './Skeleton.module.scss'

// Walmart's loaders: pale grey pieces in the shape of the block they stand in for, pulsing together.

interface ICardsSkeletonProps {
  count: number
  // The card's own size variant, so each outline takes the slot its card will take.
  kind: 'grid' | 'small' | 'banner'
  // The grid's authored cards per row; the outline follows it as the card does.
  perRow?: number | null
}

export const CardsSkeleton = ({ count, kind, perRow = null }: ICardsSkeletonProps) => {
  const { t } = useSurveyLocale()
  const viewport = useViewport()
  const sizeClass =
    'small' === kind
      ? cardStyle.small
      : 'banner' === kind
        ? cardStyle.banner
        : null !== perRow && !viewport.mobile
          ? cardStyle[`card${perRow}PerRow`]
          : ''

  // `display: contents` keeps the outlines direct items of the row or grid they stand in.
  return (
    <div
      className={style.contents}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-GridSkeleton"
    >
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={`${cardStyle.card} ${viewport.mobile ? cardStyle.cardMobile : ''} ${sizeClass}`}>
          <div className={style.photo} />
          <div className={style.title} />
          <div className={style.line} />
        </div>
      ))}
    </div>
  )
}

interface IPlateSkeletonProps {
  // The box of the block it stands in for.
  className: string
}

export const PlateSkeleton = ({ className }: IPlateSkeletonProps) => {
  const { t } = useSurveyLocale()

  return (
    <div
      className={`${style.plate} ${className}`}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-Skeleton"
    />
  )
}

interface ILinesSkeletonProps {
  count: number
}

export const LinesSkeleton = ({ count }: ILinesSkeletonProps) => {
  const { t } = useSurveyLocale()

  return (
    <div role="status" aria-label={t('questions', 'ec', 'loading')} data-testid="SW-EC-CartSkeleton">
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={style.cartLine}>
          <div className={style.thumb} />
          <div className={style.lineText}>
            <div className={style.title} />
            <div className={style.line} />
          </div>
        </div>
      ))}
    </div>
  )
}
